document.addEventListener('DOMContentLoaded', function () {
  const topSwiper = new Swiper('.bl_fvSwiper', {
    loop: true,
    slidesPerView: 'auto',
    centeredSlides: true,
    autoplay: {
    delay: 6000, 
    },
    speed: 1000,
    pagination: {
      el: '.swiper-pagination',
      clickable: false,
    },

    breakpoints: {
      640: {
        //slidesPerView: 1.5,
        spaceBetween: 10,
      },
      750: {
        //slidesPerView: 2,
        spaceBetween: 20,
      },
      1100: {
         //slidesPerView: 2.3,
        spaceBetween: 20,
      },
    },
  });
});